import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { NewsItem } from "../models/news-item";
import { NewsSlideoutService } from './news-slideout.service';
import { EMPTY, Subscription, switchMap } from 'rxjs';
import { NewsStateService } from '../news-state.service';
import { DeltaRendererService } from '../delta-renderer.service';

@Component({
    selector: 'app-news-slideout',
    templateUrl: './news-slideout.component.html',
    styleUrls: ['./news-slideout.component.sass'],
    standalone: true
})
export class NewsSlideoutComponent implements OnInit, OnDestroy {

  public show: boolean = false;
  public newsItem: NewsItem | null = null;

  renderedContent = signal<string | undefined>('');

  private subscription = new Subscription();

  constructor(private newsSlideoutService: NewsSlideoutService,
              private newsService: NewsStateService,
              private deltaRendererService: DeltaRendererService) { }

  ngOnInit(): void {
    this.subscription = this.newsSlideoutService.newsClicked$.pipe(
      switchMap(newsId => newsId ? this.newsService.getNewsItem(newsId) : EMPTY))
      .subscribe(newsItem => {
        this.newsItem = newsItem;

        let renderedContent = newsItem.deltaContent
          ? this.deltaRendererService.deltaToHtml(newsItem.deltaContent)
          : newsItem.htmlContent;

        this.renderedContent.set(renderedContent);

        this.open();
      });
  }

  open(): void {
    this.show = true;
  }

  close(): void {
    this.show = false;
    this.resetNews();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private resetNews(): void {
    this.newsItem = null;
  }
}
